import * as $ from 'jquery';
import * as jQuery from 'jquery';
import * as FC from 'fullcalendar';
import * as moment from 'moment'

import { environment } from '@env/environment';
import { providers } from 'mock/mock.base';

import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CustomFormsModule } from 'ng2-validation'
import { LaddaModule } from 'angular2-ladda';
import { ColorPickerModule } from 'ngx-color-picker';
import { ClipboardModule } from 'ngx-clipboard';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { NgSelectModule } from '@ng-select/ng-select';
// import { HotTableModule } from '@handsontable/angular';
import { FileSizeModule } from 'ngx-filesize';
// componentsng
import { NgDragDropModule } from 'ng-drag-drop';
import { DndModule } from 'ng2-dnd';
import { NgxUploaderModule } from 'ngx-uploader';
import { TreeModule } from 'angular-tree-component';
import { AppRoutingModule } from './app-routing.module';
import { MainComponent } from '@components/main/main.component';
import { NavigationComponent } from '@components/navigation/navigation.component';
import { TopnavbarComponent } from '@components/topnavbar/topnavbar.component';
import { FooterComponent } from '@components/footer/footer.component';
import { LoginComponent } from '@components/login/login.component';
import { HomeComponent } from '@components/home/home.component';

import { RoleSetupComponent } from '@components/role/role-setup.component';
import { RoleListComponent } from './components/role/role-list.component';
import { AdminUserListComponent } from './components/admin-user/admin-user-list.component';
import { AdminUserService } from './services/admin-user-service';
import { AdminUserSetupComponent } from './components/admin-user/admin-user-setup.component';


import { AppConstant } from '@constants/app.constant';
import { LocaleFilterPipe } from '@pipes/locale-filter.pipe';
import { LocaleSorterPipe } from '@pipes/locale-sorter.pipe';
import { ArraySorterPipe } from '@pipes/array-sorter.pipe';
import { EmptyAnyPipe } from '@pipes/empty-any.pipe';
import { EmptyDashPipe } from '@pipes/empty-dash.pipe';

import { LoggedInGuard } from '@guards/loggedin.guard';
import { PermissionGuard } from '@guards/permission.guard';
import { AuthorityDirective } from '@directives/authority';
// services
import { CommonService } from '@services/common.service';
import { AuthService } from '@services/auth.service';
import { MultipleDatePickerModule } from "multiple-date-picker-angular";
import { DatePipe } from '@angular/common';
import { NullDefaultValueDirective } from './directives/null-default-value-directive';
import { MyDatePickerModule } from 'mydatepicker';
import { QRCodeModule } from 'angularx-qrcode';
import { UserService } from './services/user.service';
import { ImagePreviewComponent } from './components/image-preview/image-preview.component';
import { RoleService } from './services/role.service';
import { PermissionGroupService } from './services/permission-group.service';
import { GroupService } from './services/group.service';
import { GroupListComponent } from './components/group/group-list.component';
import { GroupSetupComponent } from './components/group/group-setup.component';
import { BinaryFileService } from './services/binary-file.service';
import { CompanyService } from './services/customer/company.service'; 
import { SystemParameterSetupComponent } from './components/setting/system-parameter-setup.component';
import { SystemParameterService } from './services/system-parameter.service';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esUsLocale, zhCnLocale } from 'ngx-bootstrap/locale'
import { CodeInputModule } from 'angular-code-input';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { UserChangePasswordComponent } from './components/user/user-change-password.component';
import { NgxWangEditorModule } from 'ngx-wangeditor';
import { ProductService } from './services/product.service';
import { ProductListComponent } from './components/product/product-list.component';
import { ProductSetupComponent } from './components/product/product-setup.component';
import { OnepageTemplateListComponent } from './components/onepage-template/onepage-template-list.component';
import { OnepageTemplateSetupComponent } from './components/onepage-template/onepage-template-setup.component';
import { OrderListComponent } from './components/order/order-list.component';
import { OrderSetupComponent } from './components/order/order-setup.component';
import { OnepageTemplateService } from './services/onepage-template.service';
import { OrderService } from './services/order.service';
import { OrderReportComponent } from './components/order/order-report.component';
import { DeploymentService } from './services/deployment.service';
import { DeploymentListComponent } from './components/deployment/deployment-list.component';
import { DeploymentSetupComponent } from './components/deployment/deployment-setup.component';
import { HtmlTemplateSetupComponent } from './components/html-template/html-template-setup.component';
import { HtmlTemplateListComponent } from './components/html-template/html-template-list.component';
import { HtmlTemplateService } from './services/html-template.service';
import { UserChangeBaseInfoComponent } from './components/user/user-change-baseinfo.component';
import { UserChangeWorkingDomainComponent } from './components/user/user-change-workingdomain.component';
import { ProductSelector } from './components/product-selector/product-selector.component';
import { SystemParameterListComponent } from './components/setting/system-parameter-list.component';
import { MerchantAdminUserListComponent } from './components/merchant-user/merchant-admin-user-list.component';
import { MerchantAdminUserSetupComponent } from './components/merchant-user/merchant-admin-user-setup.component';
import { MerchantAdminUserService } from './services/merchant-user.service';
import { GeneratorComponent } from './components/system/generator/generator.component';
import { SystemCommonService } from './services/system-common.service';
import { OnepageTemplateField } from './components/onepage-template-field/onepage-template-field.component';
import { OnepageTemplateConfigComponent } from './components/onepage-template-config/onepage-template-config.component';
import { OnepageTemplateConfigListComponent } from './components/onepage-template-config/onepage-template-config-list.component';
import { OnepageTemplateConfigService } from './services/onepage-template-config.service';
import { MerchantSettingsSetupComponent } from './components/merchant-settings/merchant-settings-setup.component';
import { MerchantSettingsListComponent } from './components/merchant-settings/merchant-settings-list.component';
import { MerchantSettingsService } from './services/merchant-settings.service';

defineLocale('zh_CN', zhCnLocale);
defineLocale('zh_TW', zhCnLocale);
defineLocale('zh-cn', zhCnLocale);
defineLocale('zh-tw', zhCnLocale);
defineLocale('zh', zhCnLocale);


export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json?version=' + environment.version);
}

export const MY_MOMENT_FORMATS = {
    fullPickerInput: 'YYYY-MM-DD HH:mm',
    datePickerInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
};

@NgModule({
    declarations: [
        NullDefaultValueDirective,
        AuthorityDirective,
        LocaleFilterPipe,
        LocaleSorterPipe,
        ArraySorterPipe,
        EmptyAnyPipe,
        EmptyDashPipe,
        MainComponent,
        NavigationComponent,
        TopnavbarComponent,
        FooterComponent,
        LoginComponent,
        HomeComponent,
        RoleSetupComponent,
        RoleListComponent,
        UserChangePasswordComponent,
        UserChangeBaseInfoComponent,
        UserChangeWorkingDomainComponent,
        GroupListComponent,
        GroupSetupComponent,
        ImagePreviewComponent,
        AdminUserSetupComponent,
        AdminUserListComponent,
        MerchantAdminUserSetupComponent,
        MerchantAdminUserListComponent,
        DeploymentListComponent,
        DeploymentSetupComponent,
        ProductListComponent,
        ProductSetupComponent,
        OnepageTemplateField,
        OnepageTemplateListComponent,
        OnepageTemplateConfigListComponent,
        OnepageTemplateConfigComponent,
        OnepageTemplateSetupComponent,
        HtmlTemplateSetupComponent,
        HtmlTemplateListComponent,
        OrderListComponent,
        OrderSetupComponent,
        OrderReportComponent,
        SystemParameterSetupComponent,
        SystemParameterListComponent,
        MerchantSettingsSetupComponent,
        MerchantSettingsListComponent,
        GeneratorComponent,
        ProductSelector
    ],
    imports: [
        BrowserModule,
        CodeInputModule.forRoot({
            codeLength: 7,
            isCharsCode: true
        }),
        BrowserAnimationsModule,
        FormsModule,
        // BpmnModeler,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule,
        NgxUploaderModule,
        PaginationModule.forRoot(),
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        BsDatepickerModule.forRoot(),
        DatepickerModule.forRoot(),
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        OwlMomentDateTimeModule,
        PopoverModule.forRoot(),
        QRCodeModule,
        TooltipModule.forRoot(),
        CustomFormsModule,
        ColorPickerModule,
        FileSizeModule,
        NgxWangEditorModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgDragDropModule.forRoot(),
        DndModule.forRoot(),
        MyDatePickerModule,
        TimepickerModule.forRoot(),
        LaddaModule.forRoot({
            style: "expand-right"
        }),
        TreeModule.forRoot(),
        MultipleDatePickerModule,
        ClipboardModule,
        NgSelectModule,
        CKEditorModule,
        // HotTableModule.forRoot(),
    ],
    providers: [
        DatePipe,
        Title,
        { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
        AppConstant,
        LoggedInGuard,
        PermissionGuard,
        CommonService,
        AuthService,
        UserService,
        MerchantAdminUserService,
        PermissionGroupService,
        RoleService,
        GroupService,
        BinaryFileService,
        DeploymentService,
        ProductService,
        SystemParameterService,
        MerchantSettingsService,
        OnepageTemplateService,
        OnepageTemplateConfigService,
        HtmlTemplateService,
        OrderService,
        CompanyService,
        AdminUserService,
        SystemCommonService
        ,
        ...providers
    ],
    bootstrap: [MainComponent]
})
export class AppModule { }
